// extracted by mini-css-extract-plugin
export default {"main_container":"EditProfile_main_container__W5DC7","subtitle":"EditProfile_subtitle__bxlhY","terms_conditions":"EditProfile_terms_conditions__gFU0l"};